// Dependency-free news types/constants, safe to import from client code
// (news/load.ts pulls in gray-matter, which must stay out of the bundle).
// content/schemas.ts builds its zod enum from NEWS_CATEGORIES, so the type
// here and the validation there can't drift.
import type { MediaImage } from '../media/media-image'

export const NEWS_PAGE_SIZE = 9

/** Categories of `content/news` (press). Blog posts are in `content/blog`. */
export const NEWS_CATEGORIES = ['Press', 'Top Press', 'Press Release'] as const
export type NewsCategory = (typeof NEWS_CATEGORIES)[number]

/** What a /news card shows as its category: press categories, or `Blog` for a blog post. */
export type CardCategory = NewsCategory | 'Blog'

export const NEWS_TYPES = [
  'all',
  'top-press',
  'blog',
  'press-releases',
] as const
export type NewsType = (typeof NEWS_TYPES)[number]

/** Listing-card fields only (no body), kept small for the per-page JSON. */
export type NewsCardData = {
  slug: string
  title: string
  date: string
  /** `Blog` cards are blog posts: they link to /blog/<slug>. */
  category: CardCategory
  outlet?: string
  url?: string
  summary?: string
  image?: MediaImage
}

export type NewsPage = {
  items: NewsCardData[]
  page: number
  totalPages: number
  total: number
  type: NewsType
  /** Only on page 1 of "all": the "Featured" block. */
  featured?: NewsCardData
}

/**
 * Search facet for an item (Pagefind filter `type`; see docs/architecture.md,
 * "Search"). Values equal the `/news/<tab>` path segments so a tab filters
 * results by its own id. Plain "Press" has no tab of its own (only in All).
 */
export const searchType = (category: CardCategory) =>
  ({
    Press: 'press',
    Blog: 'blog',
    'Top Press': 'top-press',
    'Press Release': 'press-releases',
  })[category]
